import posthog from "posthog-js";

export type JobBuilderStep =
  | "basic"
  | "skills"
  | "quiz"
  | "screening"
  | "proctoring"
  | "submission";

export type JobBuilderAction =
  | "save_basic"
  | "save_description"
  | "save_skills"
  | "save_cognitive_skills"
  | "generate_skills"
  | "save_quiz"
  | "save_screening"
  | "save_proctoring"
  | "save_submission"
  | "publish_job";

interface JobAnalyticsProps {
  workspaceId?: string;
  jobId?: string;
}

export function useJobAnalytics({ workspaceId, jobId }: JobAnalyticsProps) {
  // Track step navigation
  const trackStepView = (step: JobBuilderStep) => {
    posthog.capture("job_builder_step_view", {
      step,
      workspace_id: workspaceId,
      job_id: jobId,
    });
  };

  // Track action performed
  const trackAction = (
    action: JobBuilderAction,
    properties: Record<string, any> = {}
  ) => {
    posthog.capture("job_builder_action", {
      action,
      workspace_id: workspaceId,
      job_id: jobId,
      ...properties,
    });
  };

  return {
    trackStepView,
    trackAction,
  };
}
